import {
  ErrorOutline,
  Info,
  Close,
  Warning,
  CheckCircleOutlined,
} from '@material-ui/icons';
import { IconButton } from '../IconButton';
import clsx from 'clsx';

export const ToastNotification = ({
  notification,
  onDismiss,
}: ToastNotificationProps) => {
  const classes = useStyles();

  const getIcon = (type: NotificationType) => {
    switch (type) {
      case 'error':
        return <ErrorOutline className={classes.icon} />;
      case 'warning':
        return <Warning className={classes.icon} />;
      case 'success':
        return <CheckCircleOutlined className={classes.icon} />;
      case 'info':
      default:
        return <Info className={classes.icon} />;
    }
  };

  return (
    <div className={clsx(classes.container, classes[notification.type])}>
      {getIcon(notification.type)}
      <div className={classes.messageContainer}>
        {notification.name ? (
          <p className={classes.header}>{notification.name}</p>
        ) : null}
        <p className={classes.message}>{notification.message}</p>
      </div>
      {notification.dismissible && (
        <IconButton onClick={() => onDismiss()}>
          <Close fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

const useStyles = () => ({
  container:
    'flex items-start justify-between gap-3 w-full rounded shadow-lg my-1 p-4',
  header: 'font-bold',
  icon: 'm-0',
  message: 'text-xs leading-normal opacity-80',
  messageContainer: 'flex flex-col grow',
  success: 'bg-green-100 text-green-800 border-green-600',
  error: 'bg-red-100 text-red-800 border-red-600',
  warning: 'bg-amber-100 text-amber-800 border-amber-600',
  info: 'bg-teal-100 text-teal-800 border-teal-600',
});
